import React from "react";
import styled from "styled-components";
import { Table as DsmTable } from "@plum-xoxo/admin-dsm";

const Table = styled(DsmTable).attrs()`
  .Mui-selected{
    background-color: ${(props) => props.theme.palette.primary.c00} !important;
    .MuiTableCell-root{
      background-color: ${(props) =>
        props.theme.palette.primary.c00} !important;
      border-color: ${(props) => props.theme.palette.primary.c00};
    }
  }
  .MuiCheckbox-root{
    padding-top:0;
    padding-bottom:0;
  }
  .MuiTableCell-paddingCheckbox {
    padding: 0 !important;
  }
  .MuiButtonBase-root:hover{
    background-color:transparent;
  }
  p {
    margin-bottom: 0px;
  }
  .MuiTableHead-root {
    color: ${(props) => props.theme.palette.dark.c200};
    white-space: nowrap;

    th {
      padding-top:0;
      padding-bottom:0;
      height: 40px !important;
      div {
        font-size: ${(props) => props.theme.typography.label.fontSize};
        font-weight: ${(props) => props.theme.typography.label.fontWeight};
        line-height: ${(props) => props.theme.typography.label.lineHeight};
        color: ${(props) => props.theme.palette.dark.c200};
        letter-spacing: ${(props) =>
          props.theme.typography.label.letterSpacing};
      }
    }
  }
  .MuiTableHead-root {
    ${(props) =>
      props.approval_type
        ? `
    th:nth-child(5) {
      text-align: right;
    }
    `
        : ``}
  }

  .MuiTableHead-root {
    ${(props) =>
      props.isRewardAmount
        ? `
    th:nth-child(5) {
      text-align: right; 
    }
    `
        : ``}
  }
  .MuiTableHead-root {
    ${(props) =>
      props.isPending
        ? `
    th:nth-child(4) {
      text-align: right; 
    }
    `
        : ``}
  }
  .MuiTableHead-root {
    ${(props) =>
      props.isAutomationDetailsRewardAmount
        ? `
    th:nth-child(3) {
      text-align: right; 
    }
    `
        : ``}
  }

  .MuiTableHead-root {
    ${(props) =>
      props.admin_list
        ? `
    th:nth-child(4) {
      text-align: right; 
    }
    `
        : ``}
  }
  

  .MuiTableRow-head {
       ${(props) =>
         props.admin_list
           ? `
    .MuiTableCell-head:last-child {
   text-align: center;
   }
    `
           : ``}
      
  }

  .MuiTableHead-root .MuiButtonBase-root {
    text-transform: capitalize;
  }
  .MuiTableBody-root {
    cursor: pointer;
    font-weight: 400;
    color: ${(props) => props.theme.palette.dark.c300};
  }
  .MuiTableBody-root {
    tr {
      height: 48px !important;

    }
    .MuiTableRow-hover:nth-child(odd):hover {
      background-color: transparent !important;
    }
    .MuiTableRow-hover:nth-child(even):hover {
      background-color: ${(props) => props.theme.palette.light.c100} !important;
    }
    td{
      padding-top:0;
      padding-bottom:0;
      height:auto !important;
    }
    td:nth-child(1) {
      max-width: 300px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    },
    ${(props) => {
      props.approval_type
        ? `
    td:nth-child(5) {
      text-align: right;
    }
    `
        : ``;
    }}
  }
  .MuiTableRow-root .MuiTableCell-root:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  .MuiTableRow-root .MuiTableCell-root:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .MuiTableRow-root:nth-child(even) .MuiTableCell-root:first-child,
  .MuiTableRow-root:nth-child(even) .MuiTableCell-root:last-child   {
    background-color: ${(props) => props.theme.palette.light.c100};
  }
  .MuiTableRow-root:nth-child(odd) .MuiTableCell-root:first-child ,
  .MuiTableRow-root:nth-child(odd) .MuiTableCell-root:last-child 
   {
    background-color: ${(props) => props.theme.palette.light.c000};
  }

  .MuiTableCell-root:last-child{
    position:sticky;
    right:0;
    padding: 0;
  }
  .MuiTableCell-footer{
    padding: 0px !important;
    height: 40px;
  }
  .MuiTableRow-root:nth-child(even) {
    background-color: ${(props) => props.theme.palette.light.c100};
  }
  .MuiTableCell-root {
    border-color: transparent;
    padding: 28px;
    font-weight: 400;
    font-size: 16px;
  }
  .MuiTableCell-footer{
    padding-bottom: 0;
  }
`;

const TableElement = ({ className, ...restProps }) => {
  return <Table {...restProps} className={`px-24 pt-12 box ${className}`} />;
};
export default TableElement;
